<template>
  <div class="card">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">LXD</a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">List Instances</a>
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-header"></div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center align-items-center">
          <h4 class="fw-600">LXD Management</h4>
        </div>
        <div class="col-md-3 mb-20">
          <label class="fw-16" for="">Clusters:</label>
          <multi-select id="value" v-model="selectedCluster" :options="allClusters" label="name"
                        placeholder="Select Cluster (s)"
                        track-by="name"/>
        </div>
        <div class="col-md-12">
          <table id="lxd_datatable" cellspacing="0" class="table table-striped table-bordered" width="100%">
            <thead class="thead-dark">
            <tr>
              <th>Name</th>
              <th class="text-center">Status</th>
              <th class="text-center">IP</th>
              <th class="text-center">Node</th>
              <th class="text-center">Memory Usage</th>
              <th class="text-center">Disk Usage</th>
              <th class="text-center">CPU</th>
              <th class="text-center">CPU Usage Time</th>
              <th class="text-center">Created</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
              <th>Name</th>
              <th class="text-center">Status</th>
              <th class="text-center">IP</th>
              <th class="text-center">Node</th>
              <th class="text-center">Memory Usage</th>
              <th class="text-center">Disk Usage</th>
              <th class="text-center">CPU</th>
              <th class="text-center">CPU Usage Time</th>
              <th class="text-center">Created</th>
            </tr>
            </tfoot>
            <tbody v-show="!loader">
            <tr v-for="(row, index) in instances" :key="index">
              <td width="15%"><a href="javascript:void(0)" @click="openDetails(row)">{{ row.name }}</a></td>
              <td class="text-center">
                <span v-if="row.status.toLowerCase() === 'running'"
                      class="badge badge-pill badge-rounded badge-success">Running</span>
                <span v-else-if="row.status.toLowerCase() === 'stopped'"
                      class="badge badge-pill badge-rounded badge-danger">{{ row.status }}</span>
                <span v-else class="badge badge-pill badge-rounded badge-warning">{{ row.status }}</span>
              </td>
              <td class="text-center">{{ row.ip_address }}</td>
              <td class="text-center" width="8%">{{ row.node }}</td>
              <td class="text-center" width="15%">
                <div v-if="row.memory_usage !== '-'">
                  <!-- Usage Info -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="fw-semibold">{{ row.memory_usage }} / {{ row.ram }}</span>
                    <span class="fw-semibold">{{ row.memory_usage_percent }}</span>
                  </div>

                  <!-- Progress Bar -->
                  <div class="progress" style="height: 14px; ">
                    <div
                        :aria-valuenow="row.memory_usage_percent"
                        :style="progressBarStyle(row.memory_usage_percent)"
                        aria-valuemax="100"
                        aria-valuemin="0"
                        class="progress-bar bg-success progress-bar-striped"
                        role="progressbar"
                    ></div>
                  </div>
                </div>
                <div v-else class="text-muted fw-medium">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="fw-semibold">{{ row.memory_usage }} / {{ row.ram }}</span>
                    <span class="fw-semibold">0%</span>
                  </div>

                  <!-- Progress Bar -->
                  <div class="progress" style="height: 14px; ">
                    <div
                        :aria-valuenow="0"
                        aria-valuemax="100"
                        aria-valuemin="0"
                        class="progress-bar bg-success progress-bar-striped"
                        role="progressbar"
                    ></div>
                  </div>
                </div>
              </td>
              <td width="15%">
                <div v-if="row.disk_usage !== '-'" class="mb-2">
                  <!-- Usage Info -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="fw-semibold">{{ row.disk_usage }} / {{ row.disk }}</span>
                    <span class="fw-semibold">{{ row.disk_usage_percent }}</span>
                  </div>

                  <!-- Progress Bar -->
                  <div class="progress" style="height: 14px; ">
                    <div
                        :aria-valuenow="row.disk_usage_percent"
                        :style="progressBarStyle(row.disk_usage_percent)"
                        aria-valuemax="100"
                        aria-valuemin="0"
                        class="progress-bar bg-success progress-bar-striped"
                        role="progressbar"
                    ></div>
                  </div>
                </div>

                <div v-else class="text-muted fw-medium">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="fw-semibold">{{ row.disk_usage }} / {{ row.disk }}</span>
                    <span class="fw-semibold">{{ row.disk_usage_percent }}</span>
                  </div>

                  <!-- Progress Bar -->
                  <div class="progress" style="height: 14px; ">
                    <div
                        :aria-valuenow="0"
                        aria-valuemax="100"
                        aria-valuemin="0"
                        class="progress-bar bg-success progress-bar-striped"
                        role="progressbar"
                    ></div>
                  </div>
                </div>
              </td>
              <td class="text-center">{{ row.cpu }}</td>
              <td class="text-center">{{ row.cpu_usage_time }}</td>
              <td :data-order="row.created" class="text-center">{{ formatDate(row.created) }}</td>
            </tr>
            </tbody>
            <tbody v-if="loader">
            <tr>
              <td colspan="10">
                <div class="loader"></div>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>

</template>
<script>
import moment from 'moment'
import MultiSelect from "vue-multiselect";

export default {
  name: "index",
  components: {MultiSelect},
  data() {
    return {
      instances: [],
      loader: false,
      allClusters: [{name: 'LX4 (Testing)', value: 'lx4'}, {name: 'ORD (Production)', value: 'ord'}, {name: 'EGV (Production)', value: 'egv'}, {name: 'IAD (Production)', value: 'iad'}],
      selectedCluster: {name: 'EGV (Production)', value: 'egv'},
    }
  },
  watch: {
    instances() {
      this.renderDatatable()
    },
    selectedCluster() {
      this.fetchClusterInstances()
    }
  },
  mounted() {
    this.fetchClusterInstances()
    this.renderDatatable()
  },
  methods: {
    async openDetails(data) {
      console.log(data)
      localStorage.setItem('cluster', this.selectedCluster.value)
      this.$router.push({name: 'lxd-details', params: {id: data.name}})
    },
    renderDatatable() {
      console.log('rendering')
      if ($.fn.DataTable.isDataTable('#lxd_datatable')) {
        $(`#lxd_datatable`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#lxd_datatable`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo": false,
          "ordering": true,  order: [[8, 'desc']], // Sort by first column (descending)

          "columnDefs": [
            // {"orderable": false, "targets": [8]} // Disable sorting on the first and third columns
          ],
          initComplete: function () {
            let api = this.api();
            $('.dataTables_filter input').on('input', function () {
              let newValue = $(this).val().replace(/\s/g, ''); // Remove spaces
              $(this).val(newValue);
              api.search(newValue).draw();
            });
          }
        });
      }, 0)
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("D MMM, YYYY");
    },
    getMemoryUsagePercent(row) {
      const memoryUsed = parseFloat(row.memory_usage)
      const totalRam = parseFloat(row.ram);
      return `${((memoryUsed / totalRam) * 100).toFixed(1)}%`
    },
    convertToMB(value) {
      const num = parseFloat(value); // extract numeric part
      if (value.toLowerCase().includes("gb")) {
        return num * 1024; // 1 GB = 1024 MB
      } else if (value.toLowerCase().includes("mb")) {
        return num;
      } else {
        throw new Error("Unknown unit, must be MB or GB");
      }
    },
    progressBarStyle(percentage) {
      if (!percentage || percentage === '-') return
      // Determine color gradient based on percent
      const percent = Number(percentage.split('%')[0]);
      let gradient;
      const gradientColors = [
        '#2ecc40', // Green
        '#a3e635', // Lime
        '#eab308', // Yellow
        '#f97316', // Orange
        '#ef4444', // Red
        '#b91c1c', // Deep Red
        '#7f1d1d'  // Very Deep Red
      ];
      console.log(gradientColors.slice(0, 2).join(','))
      if (percent <= 20) {
        gradient = `linear-gradient(to right, ${gradientColors[0]}, #27ae60)`;
      } else if (percent <= 40) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 2).join(',')})`;
      } else if (percent <= 60) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 3).join(',')})`;
      } else if (percent <= 75) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 4).join(',')})`;
      } else if (percent <= 90) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 5).join(',')}`;
      } else if (percent <= 95) {
        gradient = `linear-gradient(to right, ${gradientColors.slice(0, 6).join(',')})`;
      } else {
        gradient = 'linear-gradient(to right, #a3e635, red)';
      }

      return {
        width: percent + '%',
        background: gradient,
        transition: 'width 0.5s ease, background 0.5s ease'
      };
    },
    async fetchClusterInstances() {
      try {
        this.instances = []
        this.loader = true;
        const resp = await this.$http.post('/lxd/list', {
          grant_type: 'token',
          cluster: this.selectedCluster.value || 'lx4'
        })
        console.log('resp', resp.data)
        this.instances = resp.data.data.instances
        this.instances = this.instances.map(el => {
          console.log('el', el)
          if (el.memory_usage && el.ram && (el.memory_usage_percent === '-' || !el.memory_usage_percent)) {
            const usageMB = this.convertToMB(el.memory_usage);
            const totalMB = this.convertToMB(el.ram);

            if (totalMB === 0) return 0;
            el.memory_usage_percent = `${((usageMB / totalMB) * 100).toFixed(2)}%`;
          }
          if (el.disk_usage && el.disk && (el.disk_usage_percent === '-' || !el.disk_usage_percent)) {
            const usageMB = this.convertToMB(el.disk_usage);
            const totalMB = this.convertToMB(el.disk);

            if (totalMB === 0) return 0;
            el.disk_usage_percent = `${((usageMB / totalMB) * 100).toFixed(2)}%`;
          }
          return el;
        })
        // this.instances[1].disk_usage_percent = '81%'
        // this.instances[1].memory_usage = '5.8GB'
        // this.instances[2].disk_usage_percent = '100%'
        // this.instances[2].memory_usage = '3.9GB'
      } catch (e) {
        console.log(e)
      } finally {
        this.loader = false;
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin: 20px
}

.badge-success {
  background-color: #ddf6e8;
  color: #6bd098;
  font-weight: 700;
}

.badge-warning {
  background-color: #fff0e1;
  color: #fbc658;
  font-weight: 700;
}

.badge-danger {
  background-color: #FDEEED;
  color: #EE8157;
  font-weight: 700;
}
</style>
